import { Button, Chip, IconButton, TextField, Typography } from '@mui/material';
import { getOfflineData } from '../../../utils/offline-services';
import { HTTP_METHODS, invokeApi } from '../../../utils/http-service';
import { FINANCE_V2_HOSTNAME } from '../../../../common-utilities/utils/end-points';
import { FINANCE_REST_URLS } from '../../../../common-utilities/utils/end-points/finance-v2';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { HOME_TABS, getHomeTabUrl, getPoListSubIndex } from '../../../utils/home-tabs';

const CancelPo = ({ poDetails, setPODetails, navigateToDraft }) => {
  const user = getOfflineData('user');
  const navigate = useNavigate();
  const cancelPo = () => {
    invokeApi(
      HTTP_METHODS.POST,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.CANCEL_PO}${poDetails?.id}`
    )
      .then((response) => {
        if (response?.message) {
          toast.error(response?.message, { autoClose: 2000 });
          return;
        }
        toast.success('Purchase order cancelled successfully', {
          autoClose: 2000,
        });
        if (navigateToDraft) {
          // A cancelled PO only shows up under "All PO List".
          navigate(getHomeTabUrl(HOME_TABS.PO, getPoListSubIndex('cancelled')));
        }
        setPODetails((prevDetails) => ({
          ...prevDetails,
          status: 'cancelled',
        }));
      })
      .catch((err) => {
        toast.error(err.message, { autoClose: 2000 });
      });
  };

  return (
    <>
      {poDetails?.status === 'draft' &&
        parseInt(user?.id) === parseInt(poDetails?.createdBy) && (
          <Button variant="outlined" onClick={cancelPo}>
            Cancel
          </Button>
        )}
    </>
  );
};

export default CancelPo;
